import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from 'src/shared/components/ui/miscellaneous/carousel'
import { Dialog, DialogContent } from 'src/shared/components/ui/popups/dialog'

interface ImageDialogProps {
  isOpen: boolean
  onClose: () => void
  images: string[]
  initialImageIndex?: number
}

export const ImageDialog = ({ isOpen, onClose, images, initialImageIndex = 0 }: ImageDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="flex max-w-[95vw] items-center justify-around rounded-2xl border-none bg-black/75 px-4 py-8 shadow-none data-[state=open]:bg-black/75 sm:mx-0 sm:px-12 [&>button]:text-accent [&>button]:hover:text-accent/80"
        aria-describedby="images"
      >
        <div className="relative flex size-full items-center justify-center">
          <Carousel opts={{ startIndex: initialImageIndex }} className="w-full max-w-4xl" dotsColor="accent">
            <div className="relative px-8 sm:px-12">
              <CarouselContent className="items-center">
                {images.map((image, index) => (
                  <CarouselItem key={index} className="flex justify-center">
                    <img
                      src={image}
                      alt={`Image ${index + 1}`}
                      className="max-h-[70vh] w-auto rounded-2xl object-contain"
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <div className="absolute -left-4 top-1/2 -translate-y-1/2 sm:-left-8">
                <CarouselPrevious variant="accent" />
              </div>
              <div className="absolute -right-4 top-1/2 -translate-y-1/2 sm:-right-8">
                <CarouselNext variant="accent" />
              </div>
            </div>
          </Carousel>
        </div>
      </DialogContent>
    </Dialog>
  )
}
